import { ImgHTMLAttributes, SyntheticEvent } from 'react';

import { IconName } from '@optimus-web/icons';

export interface PlaceholderProps {
    backgroundVariant?: 'transparent' | 'default';
    iconName?: IconName;
    minHeight?: number;
    minWidth?: number;
}

export type ImageRatio = '1' | '16/9' | '5/2';

export interface ImageProps extends ImgHTMLAttributes<HTMLElement> {
    src: string;
    onLoad?: (event: SyntheticEvent<HTMLElement>) => void;
    shouldShowLoader?: boolean;
    loaderDelay?: number;
    forwardedRef?: React.Ref<HTMLDivElement>;
    rounded?: boolean;
    objectFit?: 'contain' | 'cover';
    objectPosition?: string;
    placeholderProps?: PlaceholderProps;
    imageRatio?: ImageRatio;
    block?: boolean;
}
